import React, { useState } from 'react';
import ReactQuill from 'react-quill';

function Quill({ value, onChange, ...props }) {
  const [fullscreen, setFullscreen] = useState(false);
  return (
    <div className={fullscreen ? "quill-editor-fullscreen" : ""} style={{ position: "relative" }}>
        {fullscreen ? <div className="d-flex quill-editor-header">
            <h4> {props.title} </h4>
            <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setFullscreen(f => !f)}
            >
                {fullscreen ? "Quitter le mode plein écran" : "Plein écran"}
            </button>
        </div> :
        <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            style={{ position: "absolute", top: 5, right: 5, zIndex: 10 }}
            onClick={() => setFullscreen(f => !f)}
        >
            {fullscreen ? "Quitter le mode plein écran" : "Plein écran"}
        </button>}
        <ReactQuill
            {...props}
            value={value}
            onChange={onChange}
            className={`quill-editor-custom ${props.className || ""}`}
            style={{ minHeight: 300 }}
        />
    </div>
  );
}

export default Quill;